module.exports = __webpack_public_path__ + "img/maehen.0671e58b.svg";